/**
 * Loads TTF fonts into jsPDF.
 *
 * 1. TTF fonts MUST first be converted to base64 on command line:
 *      $ base64 <file>.ttf > <file>.txt
 * 2. The base64 encoded string needs to be added to the exports in base64 directory
 *     $ TODO: Make a script that does 1 and 2
 * 3. Add exports to this file, with the JS PDF loader
 */
import _ from 'lodash';

import roboto from '../fonts/base64/Roboto';
import texgyreheros from '../fonts/base64/TeX-Gyre-Heros';

const fonts = _.assign(roboto, texgyreheros);

function loadFont(jsPDF, name, types) {
    _.forEach(types, (type, key) => {
        jsPDF.addFileToVFS(type.ttf, type.base64);
        jsPDF.addFont(type.ttf, name, key);
    });
}

export default function loadFonts(jsPDF) {
    _.forEach(fonts, (font, name) => {
        loadFont(jsPDF, name, font);
    });
}

export function listFonts() {
    return fonts;
}
